import React, { useState, useEffect } from 'react';
import { getFullImageUrl } from '../../../../utils/imageUtils';

const SmartImage = ({ 
    src, 
    alt = '', 
    className = '', 
    fallbackType = 'default', // 'project', 'user', 'news', 'org', 'default'
    placeholder = null,
    loading = 'lazy',
    ...props 
}) => {
    const [imgSrc, setImgSrc] = useState(null);
    const [hasError, setHasError] = useState(false);

    const getFallback = () => {
        if (placeholder) return placeholder;

        const firstLetter = alt ? alt.trim().charAt(0).toUpperCase() : '?';
        
        const fallbacks = {
            project: `data:image/svg+xml;charset=UTF-8,%3Csvg width='400' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='%23f3f4f6'/%3E%3Ctext x='50%25' y='50%25' font-family='sans-serif' font-size='24' fill='%239ca3af' text-anchor='middle' dy='.3em'%3EПроект%3C/text%3E%3C/svg%3E`,
            track: `data:image/svg+xml;charset=UTF-8,%3Csvg width='400' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='%23f5f3ff'/%3E%3Ctext x='50%25' y='50%25' font-family='sans-serif' font-size='24' fill='%23a78bfa' text-anchor='middle' dy='.3em'%3EТрек%3C/text%3E%3C/svg%3E`,
            user: `data:image/svg+xml;charset=UTF-8,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='%23e0f2fe'/%3E%3Ctext x='50%25' y='50%25' font-family='sans-serif' font-size='40' font-weight='bold' fill='%230ea5e9' text-anchor='middle' dy='.3em'%3E${encodeURIComponent(firstLetter)}%3C/text%3E%3C/svg%3E`,
            news: `data:image/svg+xml;charset=UTF-8,%3Csvg width='800' height='400' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='%23f8fafc'/%3E%3Ctext x='50%25' y='50%25' font-family='sans-serif' font-size='30' fill='%2394a3b8' text-anchor='middle' dy='.3em'%3EНовость%3C/text%3E%3C/svg%3E`,
            org: `data:image/svg+xml;charset=UTF-8,%3Csvg width='1200' height='400' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='%23f1f5f9'/%3E%3Ctext x='50%25' y='50%25' font-family='sans-serif' font-size='40' fill='%2364748b' text-anchor='middle' dy='.3em'%3EОрганизация%3C/text%3E%3C/svg%3E`,
            default: `data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7`
        };
        return fallbacks[fallbackType] || fallbacks.default;
    };

    useEffect(() => {
        const fullUrl = getFullImageUrl(src);
        if (fullUrl) {
            setImgSrc(fullUrl);
            setHasError(false);
        } else {
            setImgSrc(getFallback());
        }
    }, [src, fallbackType, alt]);

    const handleError = () => {
        if (!hasError) {
            setImgSrc(getFallback());
            setHasError(true);
        }
    };

    return (
        <img 
            src={imgSrc} 
            alt={alt} 
            className={`${className} ${hasError ? 'img-fallback' : ''}`}
            onError={handleError}
            loading={loading}
            {...props}
        />
    );
};

export default SmartImage;
